// extracted by mini-css-extract-plugin
module.exports = {"calendarStyle":"_35cjIfInffZlY2ul8-wp6S"};